
export class Translations {
    static Lang = {
        Code: ["Code", "Côd"],
        Logged: ["Logged", "Log"],
        Type: ["Type", "Math"],
        Priority: ["Priority", "Blaenoriaeth"],
        Status: ["Status", "Statws"],
        LegalType: ["Legal Type", "Cyfreithiol"],
        Parish: ["Parish", "Plwyf"],
        Reference: ["Reference", "Cyfeiriad"],
        Use: ["Use", "Defnydd"],
        Area: ["Area(ha)", "Ardal(ha)"],
        Created: ["Created", "Wedi creu"],
        RelatesTo: ["RelatesTo", "Yn Perthyn i"],
        Location: ["Location", "Lleoliad"],
        ID: ["ID", "ID"],
        ReportBy: ["ReportBy", "Adroddiad Gan"],
        Target: ["Target", "Targed"],
        LastCondition: ["Last Condition", "Amod Olaf"],
        RequiredValidation: ["Please enter a value", "Rhowch werth"]
    }
}





